export class StatusCodeLoad {
  public static readonly type = '[StatusCode] Load';
}

export class StatusCodeInitialState {
  public static readonly type = '[StatusCode] Set Initial State';
}
